import React from "react";
import { Box, Stack, Typography, Button, DrawerWithHeader } from "convertupleads-theme";
import PreviewAndEditor from "../../../common/PreviewAndEditor";

const RightDrawerWithHeaderComponent = () => {
  const [state, setState] = React.useState(false);

  const toggleDrawer = () => {
    setState(() => !state);
  };

  return (
    <Stack direction={"column"} spacing={2} p={3}>
      <Box>
        <Typography variant={"h6"} color={"text.primary"}>
          Right side Drawer with Header
        </Typography>
      </Box>
      <Box sx={{ width: "80%", alignSelf: "center" }}>
        <PreviewAndEditor
          title={"change the anchor value to 'left' for left side drawer"}
          height={"300px"}
          language="js"
          value={
            "const RightDrawerWithHeader = () => {\n" +
            "  const [state, setState] = React.useState(false);\n" +
            "\n" +
            "  const toggleDrawer = () => {\n" +
            "    setState(() => !state);\n" +
            "  };\n\n" +
            "return ( \n" +
            "<>" +
            "<Button onClick={toggleDrawer} sx={{ mr: 2 }}>\n" +
            "              Open Right Drawer\n" +
            "            </Button>\n" +
            "            <DrawerWithHeader\n" +
            '              anchor={"right"}\n' +
            "              open={state}\n" +
            "              onClose={toggleDrawer}\n" +
            '              header={"Drawer Header"}\n' +
            "            />" +
            "  );\n" +
            "</>" +
            "};\n" +
            "\n" +
            "export default RightDrawerWithHeader;"
          }
        >
          <Button onClick={toggleDrawer} sx={{ mr: 2 }}>
            Open Right Drawer
          </Button>
          <DrawerWithHeader
            anchor={"right"}
            open={state}
            onClose={toggleDrawer}
            header={"Drawer Header"}
          />
        </PreviewAndEditor>
      </Box>
    </Stack>
  );
};

export default RightDrawerWithHeaderComponent;
